// extracted by mini-css-extract-plugin
export default {"page_d":"PaginationBox_page_d__OcSQl","page_l":"PaginationBox_page_l__u5J-Y","active":"PaginationBox_active__vXFM9"};